import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { SpsPageSelectorComponent, SpsPaginationComponent } from "../components/index";
import { SpsSelectModule } from "./sps-select.module";

@NgModule({
    imports: [FormsModule, SpsSelectModule],
    declarations: [
        SpsPageSelectorComponent,
        SpsPaginationComponent
    ],
    exports: [
        SpsPageSelectorComponent,
        SpsPaginationComponent
    ]
})
export class SpsPaginationModule {}
